/**
 * ShipmentStatusBadge - Etiqueta da situação da remessa.
 * RELEASE: 2026-10-16 v1.0.0 - Versão inicial (Fase 2).
 */
import { cn } from '@/lib/utils';
import { SHIPMENT_STATUS_META, type ShipmentStatus } from './shipmentStatus';

export function ShipmentStatusBadge({ status, className }: { status: ShipmentStatus; className?: string }) {
  const meta = SHIPMENT_STATUS_META[status];
  return (
    <span className={cn('inline-flex h-5 items-center rounded-full px-2 text-[10px] font-semibold whitespace-nowrap', meta?.tone, className)}>
      {meta?.label ?? status}
    </span>
  );
}
